export default class PopupPromo {
  constructor(selector) {
    this.selector = selector;
    this.$popup = document.querySelector(selector);

    if (this.$popup) {
      this.$close = this.$popup.querySelector('.popup__close');
      this.$action = this.$popup.querySelectorAll('a');
      this.delay = parseInt(this.$popup.dataset.delay, 10) || 0;
      this.once = this.$popup.dataset.once === 'true';

      this.bindEvents();

      this.show();
    }
  }

  static init(selector) {
    return new PopupPromo(selector);
  }

  bindEvents() {
    this.$close.addEventListener('click', (event) => {
      event.preventDefault();

      this.hide(this.once);
    });

    this.$popup.addEventListener('click', (event) => {
      if (!event.target.closest('.popup__header, .popup__close, .banner')) {
        event.preventDefault();

        this.hide(this.once);
      }
    });

    if (this.once) {
      this.$action.forEach(($element) => {
        $element.addEventListener('click', () => {
          this.addCookie();
        });
      });
    }
  }

  getCookieName() {
    return this.selector.replace(/[^a-z0-9]/g, '');
  }

  hasCookie() {
    return document.cookie.match(new RegExp(`${this.getCookieName()}=1`)) !== null;
  }

  addCookie() {
    let date = new Date(new Date().getTime() + 2592000000); // месяц
    document.cookie = `${this.getCookieName()}=1; path=/; expires=${date.toUTCString()}`;
  }

  hide(forMonth) {
    if (!this.hasCookie()) {
      document.body.classList.remove('is-cropped');
      this.$popup.classList.remove('popup--open');

      if (forMonth) {
        this.addCookie();
      }
    }
  }

  show() {
    if (!this.hasCookie()) {
      setTimeout(() => {
        document.body.classList.add('is-cropped');
        this.$popup.classList.add('popup--open');
      }, this.delay);
    }
  }
}
